import React from 'react';
import { Page, Layout, Card, Text } from '@shopify/polaris';

export const Resources: React.FC = () => {
  return (
    <Page title="Resources">
      <Layout>
        <Layout.Section>
          <Card>
            <Text variant="headingMd" as="h2">
              Resources
            </Text>
            <Text as="p">
              Select which content types to translate.
            </Text>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}; 